import { render, staticRenderFns } from "./ItemEditorForm.vue?vue&type=template&id=7a72823a&"
import script from "./ItemEditorForm.vue?vue&type=script&lang=js&"
export * from "./ItemEditorForm.vue?vue&type=script&lang=js&"
import style0 from "./ItemEditorForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VForm,VTab,VTabItem,VTabs,VTabsItems})
